import React from 'react';
import { motion } from 'framer-motion';
import { Carousel } from 'nuka-carousel';
import { animationParams, animationVariants } from 'fragments';
import { TrustedCard } from './trustedCard';
import { customersTestimonials } from '../constants';
import { useWidth } from 'utils';
import { LandingSvg } from 'assets';

export const TrustedProfessionals = () => {
    const width = useWidth();

    const returnSlidesToShow = () => {
        if (width < 768) {
            return 1;
        } else if (width < 1280) {
            return 2;
        } else {
            return 3;
        }
    };

    return (
        <div className="trusted-professionals-wrapper">
            <div className="container">
                <div className="trusted-professionals-block">
                    <div style={{ overflow: 'hidden' }}>
                        <motion.h2 className="trusted-professionals-title" {...animationParams} variants={animationVariants.titleVariant}>
                            Trusted by ABA Professionals
                        </motion.h2>
                    </div>

                    <div style={{ overflow: 'hidden' }}>
                        <p className="trusted-professionals-description">See what clinics and therapists are saying about TherapyLake</p>
                    </div>

                    <div className="trusted-carousel-wrapper">
                        <Carousel className="trusted-carousel-box" showArrows="hover" scrollDistance="slide" wrapMode="nowrap">
                            {customersTestimonials.map(
                                ({ customerAvatar, customerComment, customerProfession, customerName, rating }, index) => (
                                    <div key={index} style={{ flex: `0 0 calc(${100 / returnSlidesToShow()}% - 24px)`, marginRight: 24 }}>
                                        <TrustedCard
                                            customerAvatar={customerAvatar}
                                            customerComment={customerComment}
                                            customerProfession={customerProfession}
                                            customerName={customerName}
                                            rating={rating}
                                        />
                                    </div>
                                )
                            )}
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
    );
};
